import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setCustomerTypeAction } from '../store/actions/customerTypeAction'
import FormContainer from '../components/FormContainer'
import Hero from '../components/Hero'
import CompanyLogo from '../components/CompanyLogo'
import Layout from '../components/Layout'
import theme from '../styles/theme'
import { LanguageSelector } from '../components/LanguageSelector'

const StyledHero = styled(Hero)`
    height: 160px;
`

const Header = styled.div`
    height: 100px;
`

const top = {
    small: 'small'
}

class NewBusinessCustomer extends React.Component {
    render() {
        const { data, pageContext, storeCustomerType } = this.props
        const { header, heroImage, companyLogo, customerType } = data.contentfulForm
        storeCustomerType(customerType)

        return (
            <Layout theme={theme} customerType={customerType} >
                <Header>
                    <CompanyLogo top={top.small} image={companyLogo} />
                    <LanguageSelector pageContext={pageContext} />
                </Header>
                <StyledHero top={top.small} image={heroImage} header={header} />
                <FormContainer data={data} theme={theme} />
            </Layout>
        )
    }
}

NewBusinessCustomer.propTypes = {
    data: PropTypes.object,
    pageContext: PropTypes.object,
    storeCustomerType: PropTypes.func,
}

export const query = graphql`
    query($id: String!) {
        contentfulForm(id: { eq: $id }) {
            thankYouPageBody {
                id
                thankYouPageBody
            }
            heroImage {
                fluid(quality:100, maxWidth: 1920) {
                    src
                    srcSet
                    aspectRatio
                    sizes
                }
            }
            companyLogo {
                fluid(quality: 100) {
                    src
                    srcSet
                    aspectRatio
                    sizes
                }
            }
            title
            header
            customerType
            thankYouPageTitle
            thankYouPageHeader
            nextButtonText
            cancelButtonText
            previousButtonText
            submitButtonText
            missingFieldsNotificationText
            contentViews {
                title
                header
                contentInputFields {
                    ... on ContentfulTextInputField {
                        children {
                            id
                        }
                        description {
                            description
                        }
                        header
                        id
                        integrationObjectName
                        internal {
                            type
                        }
                        placeholder
                        required
                        responseNotification
                        title
                        validationType
                        validationErrorMessage
                    }
                    ... on ContentfulRadioCheckBoxField {

                        checkboxOrRadiobutton
                        description {
                            description
                        }
                        header
                        id
                        integrationObjectName
                        internal {
                            type
                        }
                        required
                        selections {
                            title
                            header
                            value
                            mappingId
                        }
                        title
                    }

                    ... on ContentfulDropdownField {
                        dropdownSelections {
                            id
                            title
                            header
                            description {
                                description
                            }
                            value
                            mappingId
                        }
                        header
                        id
                        integrationObjectName
                        internal {
                            type
                        }
                        placeholder
                        required
                        title
                    }
                    ... on ContentfulSideBySideInputField {
                        id
                        inputFields {
                            id
                            title
                            header
                            integrationObjectName
                            required
                            placeholder
                            validationErrorMessage
                            validationType
                            responseNotification
                        }
                        internal {
                            type
                        }
                        spaceId
                        title
                    }
                    ... on ContentfulRightSideContentView {
                        contentFields {
                            ... on ContentfulRadioCheckBoxField {
                              id
                              title
                              required
                              integrationObjectName
                              header
                              checkboxOrRadiobutton
                              description {
                                description
                              }
                              internal {
                                type
                              }
                              selections {
                                title
                                header
                                value
                              }
                            }
                            ... on ContentfulTextInputField {
                              id
                              header
                              title
                              placeholder
                              required
                              responseNotification
                              validationErrorMessage
                              validationType
                              integrationObjectName
                              description {
                                description
                              }
                              children {
                                id
                              }
                              internal {
                                type
                              }
                            }
                            ... on ContentfulStaticInformationField {
                              id
                              internal {
                                type
                              }
                              integrationObjectName
                              header
                              title
                              body {
                                id
                                body
                              }
                            }
                        }
                    }
                    ... on ContentfulLeftSideContentView {
                        id
                        contentFields {
                            id
                            title
                            header
                            body {
                              body
                            }
                            integrationObjectName
                            internal {
                              type
                            }
                        }
                    }

                    ... on ContentfulStaticInformationField {
                        body {
                          id
                          body
                        }
                        integrationObjectName
                        header
                        id
                        title
                    }
                }
            }
            node_locale
        }
        site {
            siteMetadata {
                frendsApiBaseurl
                frendsApiKeyHeader
            }
        }
    }
`

const storeCustomerType = (customerTypeValue) => {
    return function(dispatch) {
        dispatch(setCustomerTypeAction(customerTypeValue))
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        storeCustomerType: bindActionCreators(storeCustomerType, dispatch),
    }
}

export default connect(undefined, mapDispatchToProps)(NewBusinessCustomer)
